"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "introdacqua": {
    "e8ae52b9": [{
      "hkey": "b2105ff1",
      "slug": "case-del-medico-torrone",
      "name": "Case del Medico-Torrone",
      "primary": true,
      "skipSearch": false
    }],
    "case-del-medico": [{
      "hkey": "b2105ff1",
      "slug": "case-del-medico-torrone",
      "name": "Case del Medico-Torrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "introdacqua"
    }],
    "3a7fcff8": [{
      "hkey": "b2105ff1",
      "slug": "case-del-medico-torrone",
      "name": "Case del Medico-Torrone",
      "primary": true,
      "skipSearch": false
    }],
    "torrone": [{
      "hkey": "b2105ff1",
      "slug": "case-del-medico-torrone",
      "name": "Case del Medico-Torrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "introdacqua"
    }]
  }
};
exports["default"] = _default;